<template>
	<div class="language-mobile">
		<div class="btn-container">
			<div class="flag">
				<img :src="languageFlag" alt="flag image" />
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { defineProps } from 'vue'

const props = defineProps({
	language: {
		type: String,
		required: true,
	},
})

const languageFlag = ref('')

const updateLanguageFlag = (language) => {
	const flags = {
		en: '/assets/images/flags/gb.svg',
		jp: '/assets/images/flags/jp.svg',
		es: '/assets/images/flags/es.svg',
		pt: '/assets/images/flags/pt.svg',
		ar: '/assets/images/flags/ar.svg',
		zh: '/assets/images/flags/ch.svg',
		ko: '/assets/images/flags/kr.svg',
	}
	languageFlag.value = flags[language] || flags['en']
}

onMounted(() => {
	const storedLanguage = localStorage.getItem('language') || props.language
	updateLanguageFlag(storedLanguage)
})
</script>
